import * as React from 'react'
import { FC } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { PaymentMethodsTable } from './Table'
import { PaymentMethodsTableHeader } from './Header'
import { useGetPaymentsOnMount } from '@user/store/payments/hooks/useGetPaymentsOnMount'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

interface Props {
  entityType: ENTITY_TYPES
  handleAddPayment: () => void
  locationId: string
  billToId: string
  canUpdate: boolean
}

export const TableWrapper: FC<Props> = (props) => {
  const { entityType, handleAddPayment, locationId, billToId, canUpdate } =
    props
  const status = useGetPaymentsOnMount(locationId)

  return (
    <>
      {status == 'pending' && (
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {status == 'success' && (
        <>
          <PaymentMethodsTableHeader
            handleAddPayment={handleAddPayment}
            billToId={billToId}
            canUpdate={canUpdate}
          />
          <PaymentMethodsTable handleAddPayment={handleAddPayment} />
        </>
      )}

      {status == 'fail' && (
        <Box p={2} display="flex" justifyContent="center">
          <Alert severity="error">
            Failed to load payments for this {entityType.toLowerCase()}.
          </Alert>
        </Box>
      )}
    </>
  )
}

TableWrapper.displayName = 'TableWrapper'
